import { render, staticRenderFns } from "./ivstTongji.vue?vue&type=template&id=20d8230c&scoped=true"
import script from "./ivstTongji.vue?vue&type=script&lang=js"
export * from "./ivstTongji.vue?vue&type=script&lang=js"
import style0 from "./ivstTongji.vue?vue&type=style&index=0&id=20d8230c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d8230c",
  null
  
)

export default component.exports